import { useEffect } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { IS_DEV } from "@/domains/main/constants/other.ts";
import {
  chatIsActiveSelector,
  chatIsEnabledSelector,
  chatIsOpenSelector,
} from "@/domains/chat/slice";

export default () => {
  const isEnabled = useAppSelector(chatIsEnabledSelector);
  const isActive = useAppSelector(chatIsActiveSelector);
  const isOpen = useAppSelector(chatIsOpenSelector);

  useEffect(() => {
    if (!isActive) return;

    if (!IS_DEV) {
      mp.invoke("setTypingInChatState", isEnabled);

      if (isEnabled) {
        mp.invoke("focus", true);
      }
    }
  }, [isEnabled, isActive]);

  // useEffect(() => {
  //   console.log({ isOpen });
  //   if (isOpen) {
  //     mp.invoke("focus", isOpen);
  //   }
  // }, [isOpen]);
};
